//
// Copyright (c) 2011-2016 by Curalate, Inc.
//

(function() {
    'use strict';

    var constants = angular.module('curalate.shared-constants', ['curalate']);

    constants.constant('VIDEO_STATUS', {
        FAILED: 'Failed',
        PROCESSING: 'Processing',
        READY: 'Ready',
        UNKNOWN: 'Unknown'
    });
})();
